import { render } from "./segmentoCadastro.vue?vue&type=template&id=610852a3"
import script from "./segmentoCadastro.vue?vue&type=script&lang=js"
export * from "./segmentoCadastro.vue?vue&type=script&lang=js"

import "./segmentoCadastro.vue?vue&type=style&index=0&id=610852a3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__